import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import cchub from "../../../assets/images/cchub.jpg";
import recycle from "../../../assets/images/recycle.jpg";
import arc from "../../../assets/images/arc.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
  borderRadius: "20px",
};

const objectList = [
  {
    icon: cchub,
    title: "CASE 1: Co-Creation Hub (CcHub)",
    subtitle: "Use Case 1: Innovation – CcHub’s Make-IT in Africa Program ",
    description:
      "AIR Fund will invest in innovation hubs in African cities to support local entrepreneurs and technologists who develop solutions addressing urban challenges in critical sectors. These hubs empower local innovators by providing ecosystem support, capacity building, tools, resources, and mentorship to build scalable, impactful solutions. One example is the Co-Creation Hub (CcHub) Make It in Africa program for university students. The program has created a thriving ecosystem where technology solutions scale and significantly impact communities. AIR Fund’s investments in similar hubs will catalyze the development of technology-driven solutions that local leaders can use to address local challenges. By investing in capacity building, mentorship, and strategic partnerships, AIR Fund will support innovation hubs in African cities to  become powerful forces for economic resilience and sustainable urban development. ",
    link: "/case-study-twiga-foods",
  },
  {
    icon: recycle,
    title: "CASE 2: EnviroServ Recycling Solutions",
    subtitle:
      "Use Case 2: Secondary City Development – WESN’s Waste-to-Energy Model",
    description:
      "Cities that invest in sustainable waste management solutions can reduce pollution, generate clean energy, and create economic opportunities through circular economy approaches. EnviroServ Recycling Solutions, a South African enterprise, has implemented waste-to-energy projects that convert organic waste into biofuels and electricity. By partnering with local governments in cities such as Durban and Johannesburg, EnviroServ has successfully reduced landfill overflow, lowered carbon emissions, and generated green jobs. AIR Fund investments in African-led urban sustainability solutions like those of EnviroServ can support the modernization of waste management systems, spur economic growth, and accelerate the adoption of renewable energy in cities across the continent.",
    link: "/case-study-teraco-data-environments",
  },
  {
    icon: arc,
    title: "CASE 3: African Risk Capacity",
    subtitle:
      "Use Case 3: Climate Resilience – African Risk Capacity (ARC) Early Warning and Response Systems",
    description:
      "African Risk Capacity (ARC), a specialized agency of the African Union, partners with governments across Africa to provide essential climate disaster insurance, risk modeling, and early warning systems. By harnessing satellite data and AI-driven predictive analytics, ARC enables governments to anticipate and prepare for droughts, floods, and cyclones, ensuring timely responses before disasters escalate. AIR Fund envisions a future where African-led climate risk management solutions, like those implemented by ARC, are at the forefront of urban resilience in secondary cities. When African governments and regional bodies strengthen early warning systems and enhance climate risk financing using ARC’s innovative methodologies, communities in these cities become better prepared for climate-related disasters. This proactive approach not only reduces economic losses but also mitigates the humanitarian crises that often follow major climate events.",
    link: "/case-study-ihub-kenya",
  },
];

const CaseStudies = () => {
  return (
    <Box margin={{ xs: "25% 0% 15% 0%", sm: "10% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "0%" }}
        color={"#39484E"}
      >
        Case-Studies of Potential Grantees
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle, description } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 4% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "25vh", sm: "200px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"2%"}
                    fontWeight={700}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"4%"}
                    color={"#000"}
                  >
                    {description}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CaseStudies;
